import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-wrap" }
const _hoisted_2 = { class: "user-table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "Name", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Anschrift", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "E-Mail", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Telefonnummer", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Geburtsdatum", -1)

import { PropType } from 'vue';
import { IUserData } from '@/classes/interfaces/data';


export default /*#__PURE__*/_defineComponent({
  props: {
  UserData: { type: Object as PropType<IUserData>, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("td", null, _toDisplayString(__props.UserData.Firstname) + " " + _toDisplayString(__props.UserData.Lastname), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(__props.UserData.Street) + " " + _toDisplayString(__props.UserData.Housenumber), 1),
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(__props.UserData.PLZ) + " " + _toDisplayString(__props.UserData.Place), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_6,
          _createElementVNode("td", null, _toDisplayString(__props.UserData.Email), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", null, _toDisplayString(__props.UserData.Phone), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, _toDisplayString(__props.UserData.Birthdate), 1)
        ])
      ])
    ])
  ]))
}
}

})